import config from "config";
import { APICore } from "helpers/api/apiCore";

const api = new APICore();

function listReportApi(params: any) {
  let backendApiUrl = `${config.BACKEND_BASE_URL}/report/saveReports`;

  return api.get(`${backendApiUrl}`, params);
}

function downloadReportApi(params: any) {
  let baseUrl = `${config.BACKEND_BASE_URL}/report/download/${params?.location}`;

  return api.getFile(`${baseUrl}`, {});
}

export { listReportApi ,downloadReportApi};
